function updateTableSize() {
	$('.table-container').each(function () {
		if ($(this).parent().hasClass('panel-body')) return;
		const containerWidth = $(this).width();
		const tableWidth = $('table', this).width();
		const tableWrapper = $(this).find('.table-wrapper');

		if (tableWidth > containerWidth) {
			$(this).addClass('scrollable');
			tableWrapper.mCustomScrollbar({
				axis: "x",
				mouseWheel: {
					enable: true
				}
			});
		} else {
			$(this).removeClass('scrollable');
			$(this).mCustomScrollbar('destroy');
		}
	});
}
